<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal';

defineEmits(['before-open', 'opened', 'close', 'click-outside', 'confirm', 'cancel']);
</script>

<template>
  <VueFinalModal
    class="clean-modal__wrapper"
    content-class="clean-modal__content"
    content-transition="vfm-slide-down"
    overlay-transition="vfm-fade"
    @closed="$emit('close')"
    @opened="$emit('opened')"
    @before-open="$emit('before-open')"
    @click-outside="$emit('click-outside')"
  >
    <slot />

    <button
      class="clean-modal__close-btn"
      name="close-modal"
      @click="$emit('close')"
    >
      <SvgoCross
        :font-controlled="false"
        class="size-7"
        filled
      />
    </button>
  </VueFinalModal>
</template>

<style lang="scss">
.clean-modal {
  &__wrapper {
    @include screen-sm {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__content {
    position: fixed;
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: hidden;
    width: 100%;
    max-width: 800px;
    max-height: 96%;
    background-color: transparent;

    @include screen-sm {
      position: relative;
    }
  }

  &__close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 130;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    padding-right: 1px;
    border-radius: 99px;
    background-color: rgb(0 0 0 / 50%);
    color: $white;
    opacity: 0.8;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
